import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Handles the hash returned from Emergent Google Auth: /dashboard#session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      const res = await exchangeGoogleSession(session_id);
      // Clean the URL hash
      window.history.replaceState(null, "", window.location.pathname);
      if (res.ok) navigate("/dashboard", { replace: true });
      else navigate("/login", { replace: true, state: { error: res.error } });
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-[#FBF9F6] font-body text-[#6B655D]"
    >
      Signing you in…
    </div>
  );
}
